import DocumentGroupContainer from './DocumentGroupContainer';

export default DocumentGroupContainer;
